import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const broadcasts = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/broadcasts", params),
  create: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/broadcasts", params),
  show: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/broadcasts/${id}`, params),
  sendNow: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/send_now`),
  duplicate: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/duplicate`),
  recipientList: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/broadcasts/${id}/recipients`, params),
  report: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/report`),
  recipients: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/broadcasts/${id}/recipients`, params),
  cancelSchedule: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/cancel_schedule`),
  rename: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/rename`),
  sendTestEmail: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/send_test_email`),
  deleteBroadcast: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}`),
  updateTemplate: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/update_template`),
  createFromSource: () =>
    buildPath(`/internal_api/broadcasts/create_from_source`),
  update: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}`),
  changeTheme: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/change_theme`),
  resetContent: ({ id }: { id: number }) =>
    buildPath(`/internal_api/broadcasts/${id}/reset_content`),
  exportRecipients: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(`/internal_api/broadcasts/${id}/export_recipients`, params),
};
